import React from "react";

import HighlightBlock from "../components/HighlightBlock";
import contactImg from "../assets/img/urla/1/f9.jpg";
export default function ContactPage() {
    return (
        <main className="about-main">
            <section>
                <div className="container">
                    <HighlightBlock bgLabel="HCP YAPI" calligraphy="Bize Ulaşın">
                        <div className="row contact-hero-inner gx-5">
                            <div className="col-lg-6 mb-4 mb-lg-0">
                                <img
                                    src={contactImg}
                                    alt="HCP Yapı"
                                    className="img-fluid rounded shadow"
                                    style={{ minHeight: 260, objectFit: "cover", width: "100%" }}
                                />
                            </div>

                            <div className="col-lg-6">
                                <div className="contact-cards ml-3">
                                    <div className="contact-card mb-5">
                                        <h5>SATIŞ OFİSİ</h5>
                                        <hr />
                                        <p><strong>T:</strong> +90 (232) 388 08 91</p>
                                        <p><strong>F:</strong> +90 (232) 388 08 91</p>
                                        <p><strong>E:</strong> info@hcpyapi.com</p>
                                        <p className="mb-0">
                                            Ahmet Efendi Mah. 1102 Sok. No:1<br />
                                            Çiğli / İzmir
                                        </p>
                                    </div>

                                    <div className="contact-card mb-5">
                                        <h5>GENEL MERKEZ</h5>
                                        <hr />
                                        <p><strong>T:</strong> +90 (232) 388 08 91</p>
                                        <p><strong>E:</strong> info@hcpyapi.com</p>
                                        <p className="mb-0">
                                            Ahmet Efendi Mah. 1102 Sok. No:1<br />
                                            Çiğli / İzmir
                                        </p>
                                    </div>

                                    <div className="main-banner__button-wrap text-center mt-4">
                                        <a
                                            href="https://wa.me/905053336335"
                                            className="main-banner__button"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Bize Ulaşın
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </HighlightBlock>
                </div>
            </section>
        </main>
    );
}
